import { Content, defaultImage, onEnvironmentChange } from '@hub/shared'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'
import './card-influencer-life.component.scoped.scss'
import { SqButton } from '@squidit/react-css'

interface Props {
  card: Content
}

export default ({ card }: Props) => {
  const onEnvironmentChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [vidaDeInfluencerUrl, setVidaDeInfluencerUrl] = useState<string>('')
  const { t } = useTranslation('cardInfluencerLife')

  useEffect(() => {
    onEnvironmentChangeSubscription.current = onEnvironmentChange?.subscribe((environment) => {
      setVidaDeInfluencerUrl(environment?.squidProducts?.vidaDeInfluencer)
    })

    return () => onEnvironmentChangeSubscription.current?.unsubscribe()
  }, [])

  return (
    <div
      className="card-influencer-life box-shadow"
      onClick={() =>
        window.open(`${vidaDeInfluencerUrl}/${card?.metadata?.location_slug}/${card?.content?.slug}?utm_source=creatorshub`, '_blank')
      }
      role="button"
      tabIndex={0}
      style={{ cursor: 'pointer' }}
    >
      <header className="image-header">
        <figure>
          <img src={card?.content?.cover_image || defaultImage} alt="" />
        </figure>
      </header>
      <main className="content">
        <h4 className="m-0" title={card?.content?.title}>
          {card?.content?.title}
        </h4>
        <main>
          <p className="description" title={card?.content?.headline} dangerouslySetInnerHTML={{ __html: card?.content?.headline }} />
          <SqButton
            className="mt-3"
            style={{ width: 'fit-content', borderWidth: '1px', fontWeight: '400', fontSize: '0.9rem' }}
            color="var(--background_secondary)"
            borderColor="var(--primary_color)"
            textColor="var(--primary_color)"
            size="md"
          >
            <i className="fa-solid fa-arrow-up-right-from-square mr-2" />
            {t('readMore')}
          </SqButton>
        </main>
      </main>
    </div>
  )
}
